import { useState } from "react";
import { Link } from "react-router-dom";

interface AdminLoginProps {
  onLogin: (email: string, password: string) => Promise<void>;
  error: string;
}

export default function AdminLogin({ onLogin, error }: AdminLoginProps) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (!email.trim() || !password) return;
    setSubmitting(true);
    await onLogin(email, password);
    setSubmitting(false);
  }

  return (
    <div className="min-h-screen bg-beige flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h2 className="font-display text-2xl text-brown mb-2">
            Área Administrativa
          </h2>
          <p className="font-body text-sm text-brown/60">
            Entre com seu e-mail e senha
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl p-6 md:p-8 space-y-4"
        >
          <div>
            <label className="font-body text-sm text-brown block mb-2">
              E-mail
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              className="w-full px-4 py-3 rounded-lg border border-nude bg-beige/50 font-body text-sm text-brown placeholder-brown/40 focus:outline-none focus:border-primary transition-colors"
              placeholder="seu@email.com"
            />
          </div>

          <div>
            <label className="font-body text-sm text-brown block mb-2">
              Senha
            </label>
            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
                className="w-full px-4 py-3 pr-10 rounded-lg border border-nude bg-beige/50 font-body text-sm text-brown placeholder-brown/40 focus:outline-none focus:border-primary transition-colors"
                placeholder="Digite sua senha"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-brown/40 hover:text-brown/70 transition-colors cursor-pointer"
                tabIndex={-1}
              >
                <i
                  className={showPassword ? "ri-eye-off-line" : "ri-eye-line"}
                />
              </button>
            </div>
          </div>

          {error && <p className="font-body text-sm text-red-500">{error}</p>}

          <button
            type="submit"
            disabled={submitting}
            className="w-full font-body text-sm px-6 py-3 rounded-full bg-primary text-white tracking-wide uppercase transition-all duration-300 hover:bg-primary-dark disabled:opacity-60 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
          >
            {submitting ? "Entrando..." : "Entrar"}
          </button>

          <div className="text-center pt-1">
            <Link
              to="/recuperar-senha"
              className="font-body text-sm text-primary hover:text-primary-dark transition-colors underline cursor-pointer"
            >
              Esqueci minha senha
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}